<form class="floating-labels" #f="ngForm" novalidate (ngSubmit)="f.form.valid && onSubmit()">
    <div class="row">
        <div class="col-md-8 offset-md-2">
            <div class="row">
                <div class="col-md-6">
                    <div class="formInput">
                        <input type="text" class="form-control" id="name" required [(ngModel)]="form.name" name="name" #name="ngModel">
                        <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="name" [translate]="'create-account/full-name'">Full Name</label>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="formInput">
                        <input type="email" class="form-control" id="email" required [(ngModel)]="form.email" name="email" #email="ngModel">
                        <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="email" [translate]="'create-account/email'">E-mail</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
            <nav>
                <button class="button-lg block purple" type="submit" [translate]="'login/submit'">
                    Submit
                </button>
            </nav>
        </div>
    </div>
</form>